import { ChevronRight } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

const LABELS: Record<string, string> = {
  dashboard: "Dashboard",
  partners: "Partners",
  organizations: "Organizations",
  locations: "Locations",
  "provider-credentials": "Credentials",
  users: "Users",
  audit: "Audit log",
  profile: "Profile",
  impersonate: "Impersonate",
};

/** Humanise "partner-foo" → "Partner foo"; UUIDs render as "Detail". */
function titleFor(segment: string): string {
  if (LABELS[segment]) return LABELS[segment] as string;
  // UUIDs (incl. the zero-padded fixtures) read poorly as breadcrumbs.
  if (/^[0-9a-f-]{8,}$/i.test(segment)) return "Detail";
  return segment
    .split("-")
    .map((s) => (s.length > 0 ? s[0]?.toUpperCase() + s.slice(1) : s))
    .join(" ");
}

export function Breadcrumbs(): JSX.Element {
  const location = useLocation();
  const parts = location.pathname.split("/").filter(Boolean);

  if (parts.length === 0) {
    return <div className="text-sm font-medium">Home</div>;
  }

  const crumbs = parts.map((segment, i) => {
    const href = "/" + parts.slice(0, i + 1).join("/");
    return { segment, href };
  });

  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-1 text-sm">
      {crumbs.map((c, i) => {
        const isLast = i === crumbs.length - 1;
        return (
          <div key={c.href} className="flex items-center gap-1">
            {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-muted-foreground" />}
            {isLast ? (
              <span className="font-medium">{titleFor(c.segment)}</span>
            ) : (
              <Link to={c.href} className="text-muted-foreground hover:text-foreground">
                {titleFor(c.segment)}
              </Link>
            )}
          </div>
        );
      })}
    </nav>
  );
}
